import script from "./DocumentSplitOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentSplitOption.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentSplitOption.vue?vue&type=style&index=0&id=01c80f8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c80f8c"]])

export default __exports__